import React from 'react';
import { ReportYear as RYComponent } from '~/components/Admin';

export function ReportYear() {
    return <RYComponent />;
}
